export default function ZonesCTA() {
  return (
    <section className="py-20 bg-slate-900">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-brand-500/20 rounded-2xl mx-auto mb-6">
          <i className="ri-map-pin-2-line text-brand-400 text-3xl"></i>
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
          Vous êtes en <span className="text-brand-400">Suisse romande</span> ?
        </h2>
        <p className="text-white/60 text-lg mb-10 max-w-2xl mx-auto">
          Peu importe votre canton — Fribourg, Berne, Vaud, Valais, Neuchâtel ou Jura — CasaReNovaPlus se déplace chez vous rapidement. Devis gratuit et sans engagement.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+41764803188"
            className="w-full sm:w-auto rounded-xl bg-brand-500 px-10 py-4 text-base font-bold text-white hover:bg-brand-600 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-3"
          >
            <i className="ri-phone-fill text-lg"></i>
            +41 76 480 31 88
          </a>
          <a
            href="tel:+41765654203"
            className="w-full sm:w-auto rounded-xl bg-teal-500 px-10 py-4 text-base font-bold text-white hover:bg-teal-600 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-3"
          >
            <i className="ri-phone-fill text-lg"></i>
            +41 76 565 42 03
          </a>
          <a
            href="mailto:info@casarenovaplus.ch"
            className="w-full sm:w-auto rounded-xl bg-white/10 border border-white/20 px-10 py-4 text-base font-bold text-white hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-3"
          >
            <i className="ri-mail-line text-lg"></i>
            info@casarenovaplus.ch
          </a>
        </div>
        <p className="mt-8 text-white/40 text-sm">
          Service d&apos;urgence disponible <strong className="text-white/60">24h/24 — 7j/7</strong> dans toute la Suisse romande
        </p>
      </div>
    </section>
  );
}
